// Provisional shape -- no endpoint or schema exists yet.
export interface ExternalStakeholder {
  name: string;
  pronouns: string | null;
  title: string | null;
  email: string;
  channels: string[];
  relationship: string | null;
  decisionAuthority: string | null;
  frequency: string | null;
  dos: string[];
  donts: string[];
  commsPreferences: string | null;
  news: string | null;
}

export interface ExternalStakeholdersResponse {
  stakeholders: ExternalStakeholder[];
  sourceLabel: string;
  updatedAt: string;
}

export const EXTERNAL_STAKEHOLDERS_FIXTURE: ExternalStakeholdersResponse = {
  sourceLabel: 'Client Comms (Email, Gong, Google Drive, Slack)',
  updatedAt: '2026-06-15',
  stakeholders: [
    {
      name: 'Alex Rivera',
      pronouns: 'she/her',
      title: 'Senior Manager, Marketing',
      email: 'alex.rivera@example.com',
      channels: ['TV/OTT', 'Audio'],
      relationship: 'Secondary POC',
      decisionAuthority: 'On owned channels only',
      frequency: 'Weekly Slack touchpoints',
      dos: ['Send the Slack recap same-day — she acts on it before the weekly'],
      donts: [
        "Don't email her; it goes unread",
        "Don't bring cross-channel asks — she only owns TV/OTT and Audio"
      ],
      commsPreferences: 'Slack, Zoom preferred; no emails',
      news:
        'Picked up an additional workstream this quarter — expect slower turnaround on ' +
        'non-Slack items.'
    },
    {
      name: 'Jordan Blake',
      pronouns: 'she/her',
      title: 'Director, Marketing',
      email: 'jordan.blake@example.com',
      channels: ['Display'],
      relationship: 'Primary POC',
      decisionAuthority: 'Account-wide decision maker',
      frequency: 'Biweekly Zoom calls',
      dos: [
        'Lead with the recommendation, then the data',
        'Loop her in on anything touching budget'
      ],
      donts: ["Don't surprise her in front of her leadership team — pre-brief first"],
      commsPreferences: 'Slack, Zoom preferred; emails okay',
      news: 'Now the approver for budget changes, replacing the prior sign-off chain.'
    },
    {
      name: 'Sam Okafor',
      pronouns: 'they/them',
      title: 'Manager, Brand Marketing',
      email: 'sam.okafor@example.com',
      channels: ['TV/OTT', 'Audio'],
      relationship: 'Day-to-day contact',
      decisionAuthority: 'No decision authority',
      frequency: 'Daily email threads',
      dos: ['Follow every Zoom with written notes'],
      donts: ["Don't assume verbal agreement carries — put it in writing"],
      commsPreferences: 'Zoom; wants a written follow-up every time',
      news:
        'Recently moved into the role — still ramping on account history, so recap context ' +
        'before diving into asks.'
    }
  ]
};
